import { identifyDebt, identifyUser, loadAnalytics, trackPageView } from "packages/integrations/segment"

loadAnalytics()

let element = document.getElementById("segment")

if (element.dataset.debtId !== undefined) {
  identifyDebt()
}

if (element.dataset.userId !== undefined) {
  identifyUser()
}

document.addEventListener("turbo:load", () => {
  trackPageView()
})
